export default __webpack_public_path__ + "static/media/Q17_1_resized.f9a7f72f.jpg";